// extracted by mini-css-extract-plugin
export default {"wrapper":"GenerationError_wrapper__ULmZ4"};